/* Packages */
import React from "react";
import { observer } from "mobx-react-lite";
import compareStore from "../store";

/* Components */
import ItemNotification from "../../customNotification";
import CompareNotificationComponent from "../../customNotification/CompareNotificationComponent";

const CompareNotification = observer(({ node, comparingUrl }) => {
    const compareItems = compareStore.compareItems;

    /* Render */
    return (
        <ItemNotification
            key={`compare-${compareItems.length}-${Date.now()}`}
            domNode={node}
            items={[...compareItems]}
            NotificationComponent={CompareNotificationComponent}
            showNotificationThreshold={1}
            autoDismissable={3500}
            showNotificationOnPageLoad={false}
            dismissable
            comparingUrl={comparingUrl}
        />
    );
});

const ObservingCompareNotificationItems = observer((props) => {
    return (
        <CompareNotification
            {...props}
        />
    );
});

export { CompareNotification, ObservingCompareNotificationItems };
